import { GetSourceDataNoteCollectionByTrialCode, SourceDataNoteCollectionResponse } from '@/api/dtos';
import { useGet, usePost } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<SourceDataNoteCollectionResponse, SourceDataNoteCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<SourceDataNoteCollectionResponse, SourceDataNoteCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useSourceDataNotesByTrialCode = (trialCode?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new GetSourceDataNoteCollectionByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default useSourceDataNotesByTrialCode;